<template>
  <div class="adput-creation">
    <div class="panel-header">
      <h3 class="panel-header__title">创意管理</h3>
      <span class="panel-header__subtitle">CREATION MANAGEMENT</span>
      <a class="panel-header__export" v-if="exportUrl" :href="exportUrl">导出</a>
    </div>
    <up-dialog v-model="refuse.visible" size="tiny" title="审核被拒原因：">
      <p class="panel-content__refuse" v-for="(item, index) in refuse.reason" :key="index">{{ item }}</p>
      <img v-if="refuse.image" :src="refuse.image">
      <up-button slot="footer" @click="refuse.visible = false">确定</up-button>
    </up-dialog>
    <div class="panel-content">
      <h3 class="panel-content__title">
        创意管理
        <up-button type="primary" class="fr" @click="operateCreation('add')">新增创意</up-button>
      </h3>
      <div class="panel-content__select-list">
        <up-select class="mr5 is-small" v-model="key" :data="selectList" @change="value = ''"></up-select>
        <up-input v-if="!['status', 'verify'].includes(key)" class="mr5" v-model="value"></up-input>
        <up-select v-else class="mr5 is-small" v-model="value" :data="key === 'status' ? statusList : verifyList"></up-select>
        <up-button type="primary" @click="searchCreation()">查询</up-button>
        <div class="fr mr20">
          <up-button type="primary" @click="batchStartAndStopCreation(selectedIds, true, true)" :loading="starting">批量开启</up-button>
          <up-button class="is-warning" type="primary" @click="batchStartAndStopCreation(selectedIds, true, false)" :loading="stopping">批量暂停</up-button>
        </div>
      </div>
      <div class="panel-content__table-wrap">
        <up-table class="panel-content__table" :page="page" :widthColumns="{ id: 160, status_msg: 100, creative_name: 200, ad_name: 120, name: 120, order_name: 200, created_at: 160 }" :slotContents="['creative_name', 'ad_name', 'order_name', 'status_msg', 'verify_msg']" show-overflow-tooltip selection pagination @cell-click="handleCellClick" @up:selection-change="handleUpSelectChange" align="center" @up:current-change="({ currentPage }) => searchCreation(currentPage)" @up:size-change="searchCreation()">
          <template slot="creative_name:content" slot-scope="{ row }">
            <router-link class="panel-content__table-link" :to="`/creation/view/${row.id}`">{{ row.creative_name }}</router-link>
          </template>
          <template slot="ad_name:content" slot-scope="{ row }">
            <router-link class="panel-content__table-link" :to="{ path: '/plans', query: { name: row.ad_name, value: 'ad_name' } }">{{ row.ad_name }}</router-link>
          </template>
          <template slot="order_name:content" slot-scope="{ row }">
            <router-link class="panel-content__table-link" :to="{ path: '/groups', query: { name: row.order_name, value: 'order_name' } }">{{ row.order_name }}</router-link>
          </template>
          <template slot="status_msg:content" slot-scope="{ row }">
            <div class="panel-content__table-status-box">
              <span class="panel-content__table-status" :class="{'is-active' : row.status_msg === '已启用'}"></span>
              <span>{{ row.status_msg }}</span>
            </div>
<!--            <div class="panel-content__table-status-box">-->
<!--              <span class="panel-content__table-status" :class="{'is-active' : row.status === 1}">{{ row.status_msg || statusMap[row.status] }}</span>-->
<!--            </div>-->
          </template>
          <template slot="verify_msg:content" slot-scope="{ row }">
            <span :class="{ 'is-refuse': row.verify === 2 }">{{row.verify_msg || verifyMap[row.verify]}}</span>
          </template>
          <template slot="up:operate">
            <up-table-column width="54" fixed="right" label="开关">
              <template slot-scope="{ row, $index }">
                <up-switch v-if="row.status !== 2" :value="row.status === 1" @change="startAndStopCreation(row, $index)"></up-switch>
              </template>
            </up-table-column>
            <up-table-column width="204" fixed="right" label="操作">
              <template slot-scope="{ row }">
                <!--<template v-if="typeof row.is_delete !== 'undefined' && row.is_delete !== 1 || row.status !== 2">
                  <up-tooltip effect="dark" placement="top" content="编辑" v-if="row.status === 0">
                    <i class="panel-content__table-icon iconfont icon-edit" @click="operateCreation('edit', row)"></i>
                  </up-tooltip>
                  <up-tooltip effect="dark" placement="top" :content="row.status === 0 ? '开启' : '暂停'">
                    <span>
                      <i v-show="!loadings[$index]" class="panel-content__table-icon iconfont" :class="row.status === 0 ? 'icon-play' : 'icon-pause'" @click="startAndStopCreation(row, $index)"></i>
                      <i v-show="loadings[$index]" class="panel-content__table-icon el-icon el-icon-loading"></i>
                    </span>
                  </up-tooltip>
                  <up-tooltip effect="dark" placement="top" content="停止">
                    <i class="panel-content__table-icon iconfont icon-stop" @click="removeCreation(row)"></i>
                  </up-tooltip>
                </template>
                <up-tooltip effect="dark" placement="top" content="查看">
                  <i class="panel-content__table-icon iconfont icon-look" @click="operateCreation('view', row)"></i>
                </up-tooltip>
                <up-tooltip effect="dark" placement="top" content="复制">
                  <i class="panel-content__table-icon iconfont icon-fuzhi" @click="operateCreation('copy', row)"></i>
                </up-tooltip>-->
                <div>
                  <up-button v-if="row.status === 0" class="is-edit" size="small" type="primary" @click="operateCreation('edit', row)">编辑</up-button>
                  <up-button class="is-view" size="small" type="primary" @click="operateCreation('view', row)">查看</up-button>
                  <!--<up-button class="is-mini" size="small" type="primary" @click="startAndStopCreation(row, $index)" :loading="loadings[$index]">开始</up-button>-->
                  <up-button v-if="row.status !== 2" class="is-remove" size="small" type="primary" @click="removeCreation(row)">停止</up-button>
                  <up-button class="is-mini" size="small" type="primary" @click="operateCreation('copy', row)">复制</up-button>
                </div>
              </template>
            </up-table-column>
          </template>
        </up-table>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
// import { get, capturedGet, capturedRemove, capturedPost } from '@/agent/http'
import { BASE_URL } from '@/global/util/constants'
import { mapActions } from 'vuex'

export default {
  name: 'creation',
  data () {
    return {
      platform: '',
      selectList: [],
      verifyList: [],
      verifyMap: {},
      statusList: [],
      statusMap: {},
      key: '',
      value: '',
      page: new this.$page(),
      selectedIds: [],
      starting: false,
      stopping: false,
      loadings: [],
      refuse: {
        visible: false,
        reason: [],
        image: ''
      }
    }
  },
  computed: {
    exportUrl () {
      const params = { page: 1, count: 5000 }
      if (this.key && this.value) {
        params[this.key] = this.value
      }
      return BASE_URL + `/${this.platform}/creative/export?` + qs.stringify(params)
    }
  },
  methods: {
    ...mapActions([
      'creation/removeCreation',
      'creation/batchStartAndStopCreation',
      'creation/getCreations',
      'creation/getSelectData'
    ]),
    // 新增创意
    operateCreation (type, row) {
      this.$router.push(`/creation/${type}${type !== 'add' ? '/' + row.id : ''}`)
    },
    // 查询创意
    searchCreation (currentPage = 1) {
      this.page.currentPage = currentPage
      if (this.key && this.value) {
        this.getCreations({ [this.key]: this.value })
      } else {
        this.getCreations()
      }
    },
    // 0 暂停中, 1 投放中, 2 已停止
    async startAndStopCreation (row, index) {
      if (row.verify !== 1) {
        return this.$message.error('审核未通过，创意不可以投放！')
      }
      this.batchStartAndStopCreation([row.id], false, row.status === 0, index)
    },
    async removeCreation (row) {
      this.$msgbox({
        title: '温馨提示',
        message: `确定要删除ID为 “${row.id}” 的创意吗？`,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            const [err, res] = await this['creation/removeCreation']({ platform: this.platform, id: row.id })
            instance.confirmButtonLoading = false;
            if (err || res.code !== 1) this.$message({ type: 'error', message: '删除创意失败！' })
            else if (res.code === 1) this.$message({ type: 'success', message: '删除创意成功！' })
            done()
          } else {
            done();
          }
        }
      }).then(_ => {
        this.getCreations()
      })
    },
    handleCellClick (row, column) {
      if (column.property !== 'verify_msg' || row.verify !== 2) return
      this.refuse.visible = true
      this.refuse.reason = (row.verify_message || '').split(/[\n↵]/g)
      this.refuse.image = row.verify_msg_pic
    },
    handleUpSelectChange ({ selection, selectAll }) {
      this.selectedIds = selection.map(v => v.id)
    },
    // 批量开启/暂停广告组
    async batchStartAndStopCreation (ids, batch, isStart, index) {
      if (batch) {
        if (!ids.length) {
          return this.$message.error(`你还没有选中要批量${isStart ? '开启' : '暂停'}的创意`)
        }

        const noverifyData = this.page.data.filter(item => ids.indexOf(item.id) > -1 && item.verify !== 1)
        if (noverifyData.length > 0) {
          return this.$message.error('存在审核未通过或已拒绝的创意！')
        }
      }

      let text = isStart ? '开启' : '暂停'
      const status = isStart ? 'starting' : 'stopping'
      if (batch) {
        this[status] = true
        text = '批量' + text
      } else {
        this.loadings.splice(index, 1, true)
      }

      const [err, res] = await this['creation/batchStartAndStopCreation']({ platform: this.platform, isStart, ids })
      if (batch) {
        this[status] = false
      } else {
        this.loadings.splice(index, 1, false)
      }
      if (err || res.code !== 1) this.$message.error(`${text}创意失败！`)
      else {
        this.$message.success(`${text}创意成功！`)
        this.getCreations()
      }
    },
    async getCreations (params = {}) {
      const { pageSize, currentPage } = this.page
      this.page.loading = true
      const [, { data: { header, data: { data: { data, total } } } }] = await this['creation/getCreations']({
        platform: this.platform,
        params: {
          per_page: pageSize,
          page: currentPage,
          ...params
        }
      })
      this.page.setData({ header, data, total })
      this.loadings = Array.from({ length: data.length }, Boolean)
    },
    async getSelectData () {
      const [, { data: { arr1: selectList, verify: verifyList, status: statusList } }] = await this['creation/getSelectData']({ platform: this.platform })
      this.selectList = selectList
      this.verifyList = verifyList
      this.verifyMap = verifyList.reduce((prev, cur) => {
        prev[cur.value] = cur.name
        return prev
      }, {})
      this.statusList = statusList
      this.statusMap = statusList.reduce((prev, cur) => {
        prev[cur.value] = cur.name
        return prev
      }, {})
    }
  },
  created () {
    this.platform = this.$route.meta.platform
    this.getSelectData()

    const { name, value } = this.$route.query
    if (name && value) {
      this.key = value
      this.value = name
      this.getCreations({ [value]: name })
    } else {
      this.getCreations()
    }
  }
}
</script>

<style lang="scss">
@include b(adput-creation) {
  //body
}
</style>
